import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const CHECKOUT_KEY_PREFIX = 'td_checkout_idempotency_';

export const SubscriptionStatusPage = ({ success = false }) => {
  const { user } = useAuth();

  useEffect(() => {
    try {
      const keysToDelete = [];
      for (let i = 0; i < sessionStorage.length; i += 1) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith(CHECKOUT_KEY_PREFIX)) {
          keysToDelete.push(key);
        }
      }
      keysToDelete.forEach((key) => sessionStorage.removeItem(key));
    } catch {
      /* sessionStorage may be unavailable (private mode / iframe sandbox) — safe to skip */
    }
  }, []);

  const title = success ? 'Subscription payment successful' : 'Subscription payment cancelled';
  const body = success
    ? 'Your payment was confirmed. Subscription state will be updated automatically.'
    : 'Payment was cancelled. You can retry checkout any time.';
  const dashboardRoute = user?.role === 'coach'
    ? '/coach/dashboard'
    : user?.role === 'admin'
    ? '/admin/dashboard'
    : '/dashboard';

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-xl bg-white border border-slate-200 p-8">
        <h1 className="text-2xl font-light tracking-tight mb-3">{title}</h1>
        <p className="text-text-muted mb-6">{body}</p>
        <div className="flex gap-3">
          <Link to="/subscription" className="btn-primary">
            Back to subscription
          </Link>
          <Link to={dashboardRoute} className="btn-secondary">
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionStatusPage;
